// Add index to cards in list layout
document.querySelectorAll('.list-card[data-layout="list"]').forEach((list) => {
  list.querySelectorAll(".skip-card").forEach((card, index) => {
    card.dataset.index = String(index + 1).padStart(2, "0");
  });
});
